module.exports = __webpack_public_path__ + "static/media/ilha_6.602b6be3.jpg";